export const PALAVRAS_PT: Record<string, string> = {
  smile: 'sorriso sorrindo sorrir feliz alegre',
  smiley: 'sorriso sorrindo feliz',
  smiling: 'sorrindo sorriso feliz',
  grin: 'sorriso sorrindo risada',
  grinning: 'sorrindo sorriso',
  beaming: 'sorrindo radiante',
  laugh: 'risada rindo rir kkk',
  laughing: 'rindo risada kkk',
  joy: 'alegria rindo chorando de rir kkk',
  rofl: 'rolando de rir kkk',
  happy: 'feliz alegre',
  sad: 'triste tristeza',
  cry: 'chorar chorando choro triste',
  crying: 'chorando choro',
  tear: 'lagrima lágrima chorando',
  tears: 'lagrimas lágrimas chorando',
  sob: 'chorando muito choro',
  angry: 'bravo raiva irritado zangado',
  mad: 'bravo raiva furioso',
  rage: 'raiva furia fúria',
  pout: 'emburrado bravo',
  love: 'amor amo apaixonado',
  heart: 'coracao coração amor',
  hearts: 'coracoes corações amor',
  kiss: 'beijo beijinho',
  kissing: 'beijando beijo',
  wink: 'piscada piscando',
  cool: 'legal descolado',
  sunglasses: 'oculos óculos escuros',
  thinking: 'pensando pensativo hmm',
  think: 'pensar pensando',
  surprised: 'surpreso surpresa',
  surprise: 'surpresa surpreso',
  astonished: 'espantado surpreso',
  open_mouth: 'boca aberta surpreso',
  shocked: 'chocado',
  scream: 'grito gritando medo',
  fear: 'medo',
  fearful: 'medo assustado',
  scared: 'assustado medo',
  sick: 'doente enjoado',
  nauseated: 'enjoado nojo',
  vomiting: 'vomitando',
  mask: 'mascara máscara doente',
  sleep: 'dormir sono',
  sleeping: 'dormindo sono',
  sleepy: 'sono sonolento',
  tired: 'cansado',
  yawning: 'bocejo bocejando sono',
  sweat: 'suor suando nervoso',
  relieved: 'aliviado alivio alívio',
  pensive: 'pensativo triste',
  confused: 'confuso',
  worried: 'preocupado',
  disappointed: 'decepcionado',
  unamused: 'sem graca sem graça entediado',
  neutral: 'neutro serio sério',
  expressionless: 'inexpressivo',
  frowning: 'carrancudo triste',
  pleading: 'suplicando por favor pidao pidão',
  innocent: 'inocente anjinho',
  blush: 'corado envergonhado timido tímido',
  upside: 'de cabeca para baixo de cabeça para baixo',
  smirk: 'sorriso de lado malicioso',
  tongue: 'lingua língua',
  yum: 'delicia delícia gostoso',
  zany: 'louco maluco',
  crazy: 'louco maluco',
  silly: 'bobo',
  nerd: 'nerd',
  clown: 'palhaco palhaço',
  cowboy: 'caubói caubo',
  hugging: 'abraco abraço',
  hug: 'abraco abraço',
  shushing: 'silencio silêncio',
  zipper: 'boca fechada ziper zíper',
  lying: 'mentiroso mentira',
  money: 'dinheiro grana',
  dollar: 'dinheiro dolar dólar',
  star: 'estrela',
  struck: 'deslumbrado',
  heart_eyes: 'apaixonado',
  exploding: 'explodindo cabeca cabeça',
  dizzy: 'tonto',
  hot: 'calor quente',
  cold: 'frio gelado',
  party: 'festa comemoracao comemoração',
  partying: 'festa comemorando',
  tada: 'festa parabens parabéns comemoracao',
  celebration: 'comemoracao comemoração',
  gift: 'presente',
  cake: 'bolo',
  birthday: 'aniversario aniversário parabens parabéns',
  balloon: 'balao balão',
  '+1': 'joinha positivo curti legal ok',
  thumbsup: 'joinha positivo curti',
  thumbsdown: 'negativo nao curti não curti',
  like: 'curtir curti',
  ok: 'ok certo',
  clap: 'palmas aplausos parabens',
  pray: 'orar rezar por favor obrigado amem amém',
  please: 'por favor',
  thanks: 'obrigado obrigada valeu',
  hand: 'mao mão',
  hands: 'maos mãos',
  wave: 'tchau oi ola olá acenando',
  handshake: 'aperto de mao aperto de mão acordo',
  point: 'apontando',
  muscle: 'forte musculo músculo forca força',
  strong: 'forte',
  facepalm: 'vergonha alheia',
  shrug: 'sei la sei lá tanto faz',
  fingers: 'dedos',
  crossed: 'cruzados sorte',
  victory: 'vitoria vitória paz',
  fire: 'fogo',
  '100': 'cem perfeito',
  check: 'certo confirmado ok',
  heavy_check_mark: 'certo confirmado',
  x: 'errado nao não cancelar',
  warning: 'atencao atenção aviso cuidado',
  question: 'pergunta duvida dúvida',
  exclamation: 'exclamacao exclamação importante',
  eyes: 'olhos olhando',
  eye: 'olho',
  poop: 'coco cocô',
  ghost: 'fantasma',
  skull: 'caveira morto',
  devil: 'diabo capeta',
  angel: 'anjo',
  monkey: 'macaco',
  dog: 'cachorro cao cão',
  cat: 'gato',
  rocket: 'foguete',
  car: 'carro',
  house: 'casa',
  home: 'casa lar',
  phone: 'telefone celular',
  computer: 'computador',
  book: 'livro',
  clock: 'relogio relógio hora',
  hourglass: 'ampulheta tempo espera',
  calendar: 'calendario calendário data',
  email: 'email e-mail',
  mail: 'correio carta',
  envelope: 'envelope carta',
  lock: 'cadeado',
  key: 'chave',
  bulb: 'lampada lâmpada ideia',
  bell: 'sino notificacao notificação',
  pizza: 'pizza',
  coffee: 'cafe café',
  beer: 'cerveja',
  wine: 'vinho',
  food: 'comida',
  soccer: 'futebol bola',
  ball: 'bola',
  trophy: 'trofeu troféu campeao campeão',
  music: 'musica música',
  sun: 'sol',
  moon: 'lua',
  rain: 'chuva',
  cloud: 'nuvem',
  snow: 'neve',
  flower: 'flor',
  rose: 'rosa flor',
  tree: 'arvore árvore',
  brazil: 'brasil',
  flag: 'bandeira',
  red: 'vermelho',
  green: 'verde',
  blue: 'azul',
  yellow: 'amarelo',
  purple: 'roxo',
  black: 'preto',
  white: 'branco',
  orange: 'laranja',
  broken: 'partido quebrado',
  sparkles: 'brilho',
  baby: 'bebe bebê',
  man: 'homem',
  woman: 'mulher',
  boy: 'menino',
  girl: 'menina',
  family: 'familia família',
};
